import { render, staticRenderFns } from "./VEstimateChatForm.vue?vue&type=template&id=18869c12&"
import script from "./VEstimateChatForm.vue?vue&type=script&lang=ts&"
export * from "./VEstimateChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports